import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { SavingsWithdrawTxOverview, SendModeExtension } from '../types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'
import { SavingsAccount } from '@/features/savings/logic/savings-converters/types'

export interface CreateTxOverviewParams {
  formValues: TransferFromUserFormNormalizedData
  sendModeExtension: SendModeExtension | undefined
  savingsAccount: SavingsAccount
  savingsTokenBalance: NormalizedNumber
  shouldRedeem: boolean
}
export function createTxOverview({
  formValues,
  sendModeExtension,
  savingsAccount,
  savingsTokenBalance,
  shouldRedeem,
}: CreateTxOverviewParams): SavingsWithdrawTxOverview {
  const providedBy =
    savingsAccount.savingsToken.symbol === TokenSymbol('sUSDC') || savingsAccount.savingsToken.symbol.startsWith('sp')
      ? 'spark'
      : 'sky'
  const converter = savingsAccount.converter

  const outTokenAmount = shouldRedeem ? converter.convertToAssets({ shares: savingsTokenBalance }) : formValues.value

  if (outTokenAmount.eq(0)) {
    return { status: 'no-overview', providedBy, savingsToken: savingsAccount.savingsToken }
  }

  const tokenToReceive = formValues.token
  const tokenToReceiveAmount = outTokenAmount
  const underlyingTokenDepositedBefore = savingsAccount.converter.convertToAssets({ shares: savingsTokenBalance })
  const underlyingTokenDepositedAfter = NormalizedNumber.max(
    underlyingTokenDepositedBefore.minus(outTokenAmount),
    NormalizedNumber.ZERO,
  )
  const mode = sendModeExtension
    ? { type: 'send' as const, receiver: sendModeExtension.receiver }
    : { type: 'withdraw' as const }

  return {
    status: 'success',
    providedBy,
    underlyingToken: savingsAccount.underlyingToken,
    tokenToReceive,
    tokenToReceiveAmount,
    underlyingTokenDepositedBefore,
    underlyingTokenDepositedAfter,
    mode,
    savingsToken: savingsAccount.savingsToken,
  }
}
